import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const SampleShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="Sample Section"
    sectionKey="Sample"
    backRoute="/sections/sample"
  />
);

export default SampleShipmentRequest;
